import {qiniuImageView3 as qi} from '../libs/common_funcs'

export const qiniuImageView3 = (value, ...args) => {
    return qi.apply(null, [value, ...args])
}



// WEBPACK FOOTER //
// ./src/filters/qiniu_imageview3.js